<div id="main-container" class="col-md-4 gradientBg">
  <h1>{{ mainTitle }}</h1>
</div>
@for (list of lists; track list) {
  <div id="questionLists" class="col-md-10 mt-5">
    <h2>{{ list.title }}</h2>
    <p>
      {{ list.text }}
    </p>
    <p>
      {{ list.text2 }}
    </p>
    <div class="row pb-3 mt-4">
      @for (first of firsts; track first) {
        <div
          class="col-lg-4 col-md-6 mb-3 d-flex flex-column"
          >
          <div class="card mb-4 h-100 border-0" style="height: 20rem">
            <mdb-card>
              <a href="{{ first.href }}" target="_blank">
                <img
                  src="{{ first.img }}"
                  class="card-img-top"
                  alt="{{ first.alt }}"
                  title="{{ first.title }}"
                  />
                </a>
              </mdb-card>
            </div>
          </div>
        }
      </div>
    </div>
  }
